import { blackColors, backgroundColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const customCircularProgressStyle = () => ({
	circularProgressWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		padding: '16px 0',
		background: `rgba(${hexToRgb(backgroundColor[0])}, 0.55)`,
		'& > div:nth-child(2)': {
			marginTop: '8px',
		},
		'& > div': {
			position: 'relative',
		},
	},
	backgroundCircle: {
		color: blackColors[5],
		position: 'absolute',
		top: 0,
		left: 0,
	},
	transparentCircularProgressWrapper: {
		backgroundColor: 'transparent',
	},
	whiteBackgroundCircuralProgressWrapper: {
		backgroundColor: 'rgba(255,255,255,0.55)',
	},
});

export default customCircularProgressStyle;
